<template>
  <jd-dialog
    :title="type == 'add' ? '添加资料' : '修改资料'"
    :visible.sync="dialogVisible"
    width="600px"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <el-form :model="formData" label-width="120px" ref="editForm">
      <el-form-item label="用户pin:" required>
        <el-input
          v-model="formData.customerPin"
          class="w-input"
          :disabled="type === 'edit'"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户昵称:" required>
        <el-input
          :disabled="type === 'edit'"
          v-model="formData.memberNick"
          class="w-input"
        ></el-input>
      </el-form-item>

      <el-form-item v-if="shouldShowField('姓名')" label="姓名:" required>
        <el-input v-model="formData.name" class="w-input"></el-input>
      </el-form-item>
      <el-form-item v-if="shouldShowField('手机号')" label="手机号:" required>
        <el-input v-model="formData.mobile" class="w-input"></el-input>
      </el-form-item>
      <el-form-item v-if="shouldShowField('订单号')" label="订单号:" required>
        <el-input v-model="formData.orderId" class="w-input"></el-input>
      </el-form-item>
      <el-form-item v-if="shouldShowField('地址')" label="地址:" required>
        <el-input v-model="formData.address" class="w-input"></el-input>
      </el-form-item>
      <el-form-item v-if="shouldShowField('地址')" label="详细地址:" required>
        <el-input v-model="formData.detailedAddress" class="w-input"></el-input>
      </el-form-item>
      <template v-for="item in expendFile">
        <el-form-item v-if="item.type == 1" :label="item.name + ':'" required>
          <el-input v-model="item.value" class="w-input"></el-input>
        </el-form-item>
        <el-form-item v-if="item.type == 2" :label="item.name + ':'" required>
          <div class="review-images-upload">
            <el-upload
              action="/jd-hd-web/image/upload"
              list-type="picture-card"
              :file-list="item.fileList || []"
              :before-upload="(file) => onBeforeUpload2(file, item)"
              :on-success="
                (res, file, fileList) =>
                  onUploadSuccess2(res, file, fileList, item)
              "
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (file, fileList) => handleRemove2(file, fileList, item)
              "
              multiple
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="upload-tips">
              最多上传9张图片，支持jpg、png格式，单张图片不超过1MB
            </div>
          </div>
        </el-form-item>
      </template>
      <el-form-item
        v-if="shouldShowField('评价截图')"
        :label="`评价截图(${fileList.length}/9):`"
        required
      >
        <div class="review-images-upload">
          <el-upload
            action="/jd-hd-web/image/upload"
            list-type="picture-card"
            :file-list="fileList"
            :before-upload="onBeforeUpload"
            :on-success="onUploadSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            multiple
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="upload-tips">
            最多上传9张图片，支持jpg、png格式，单张图片不超过1MB
          </div>
        </div>
      </el-form-item>
    </el-form>

    <!-- 图片预览弹窗 -->
    <ShowImage
      :visible.sync="previewDialogVisible"
      :imageUrl="previewImageUrl"
    />
  </jd-dialog>
</template>

<script>
import ShowImage from "./showImage.vue";
import { addUserProfile } from "@/api/jhk/politely.js";
export default {
  name: "EditShowDataDialog",
  components: {
    ShowImage,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "add",
    },
    activityId: {
      type: String,
      default: "",
    },
    ruleFieldsList: {
      type: Array,
      default: () => [],
    },
    expendFields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      formData: {
        customerPin: "",
        memberNick: "",
        name: "",
        orderId: "",
        mobile: "",
        address: "",
        detailedAddress: "",
        commentImage: "",
      },
      fileList: [], // 文件列表
      previewDialogVisible: false, // 预览弹窗显示状态
      previewImageUrl: "", // 预览图片URL
      expendFile: [], // 拓展信息
    };
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.formData = {
          customerPin: "",
          memberNick: "",
          name: "",
          orderId: "",
          mobile: "",
          address: "",
          detailedAddress: "",
          commentImage: "",
          ...this.initialData,
        };
        // 初始化文件列表
        this.fileList = this.initialData.commentImage
          ? this.initialData.commentImage.split(",").map((url, index) => ({
              name: `image-${url}`,
              url: url,
              uid: url,
            }))
          : [];
        if (
          this.expendFields &&
          this.expendFields.staticInfoNames &&
          this.expendFields.staticInfoNames.length > 0
        ) {
          const staticData = JSON.parse(
            JSON.stringify(this.expendFields.staticInfoNames)
          );
          if (this.type == "add") {
            this.expendFile = staticData.map((item) => {
              return {
                ...item,
                value: "",
              };
            });
          } else {
            this.expendFile = staticData.map((item) => {
              return {
                ...item,
                fileList:
                  item.value && item.value.trim()
                    ? item.value.split(",").map((url, index) => ({
                        name: `image-${url}`,
                        url: url,
                        uid: url,
                      }))
                    : [],
              };
            });
          }
        } else {
        }
        // console.log("--- ~ expendFile:---", this.expendFile);
      }
    },
    dialogVisible(newVal) {
      this.$emit("update:visible", newVal);
    },
    expendFields(newVal) {
      if (newVal && newVal.staticInfoNames && newVal.length > 0) {
        const staticData = JSON.parse(JSON.stringify(newVal.staticInfoNames));
        if (this.type == "add") {
          this.expendFile = staticData.map((item) => {
            return {
              ...item,
              value: "",
            };
          });
        } else {
          this.expendFile = staticData.map((item) => {
            return {
              ...item,
              fileList: item.value.split(",").map((url, index) => ({
                name: `image-${url}`,
                url: url,
                uid: url,
              })),
            };
          });
        }
      }
    },
  },
  methods: {
    // 判断是否应该显示某个字段
    shouldShowField(fieldName) {
      return this.ruleFieldsList.includes(fieldName);
    },
    // 上传图片前校验
    onBeforeUpload(file) {
      // 检查图片数量限制
      if (this.fileList.length >= 9) {
        this.$message.warning("最多只能上传9张图片");
        return false;
      }
      // 校验文件大小
      const isLt1M = file.size < 1024 * 1024 * 1;
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过 1MB");
        return false;
      }
      // 校验文件类型
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".jpeg"];
      const isType = sorts.includes(type);
      if (!isType) {
        this.$message.error("所选文件格式不符，请重新选择（支持jpg、png格式）");
        return false;
      }
      return true;
    },
    // 上传成功
    onUploadSuccess(res, file, fileList) {
      if (res.code != 1) {
        this.$message.error(res.message || "上传失败");
        // 上传失败时，从文件列表中移除该文件
        this.fileList = fileList.filter((item) => item.uid !== file.uid);
      } else {
        // 更新文件列表中对应文件的URL
        this.fileList = [...fileList];
        const targetFile = this.fileList.find((item) => item.uid === file.uid);
        if (targetFile) {
          targetFile.url = res.data;
        }
        this.$message.success("图片上传成功");
      }
    },
    // 删除图片
    handleRemove(file, fileList) {
      this.fileList = [...fileList];
    },
    // 上传图片前校验
    onBeforeUpload2(file, item) {
      // 检查图片数量限制 - 修改为检查对应item的fileList
      const currentFileList = item.fileList || [];
      if (currentFileList.length >= 9) {
        this.$message.warning("最多只能上传9张图片");
        return false;
      }
      // 校验文件大小
      const isLt1M = file.size < 1024 * 1024 * 1;
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过 1MB");
        return false;
      }
      // 校验文件类型
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".jpeg"];
      const isType = sorts.includes(type);
      if (!isType) {
        this.$message.error("所选文件格式不符，请重新选择（支持jpg、png格式）");
        return false;
      }
      return true;
    },
    // 上传成功
    onUploadSuccess2(res, file, fileList, item) {
      if (res.code != 1) {
        this.$message.error(res.message || "上传失败");
        // 上传失败时，从文件列表中移除该文件
        item.fileList = fileList.filter(
          (fileItem) => fileItem.uid !== file.uid
        );
      } else {
        // 更新文件列表中对应文件的URL
        item.fileList = [...fileList];
        const targetFile = item.fileList.find(
          (fileItem) => fileItem.uid === file.uid
        );
        if (targetFile) {
          targetFile.url = res.data;
        }
        // 将所有图片URL存储到item.value中，用逗号分隔
        const imageUrls = item.fileList
          .filter((fileItem) => fileItem.url)
          .map((fileItem) => fileItem.url)
          .join(",");
        item.value = imageUrls;
        this.$message.success("图片上传成功");
      }
    },
    // 删除图片
    handleRemove2(file, fileList, item) {
      item.fileList = [...fileList];
      // 更新item.value，移除被删除的图片URL
      const imageUrls = item.fileList
        .filter((fileItem) => fileItem.url)
        .map((fileItem) => fileItem.url)
        .join(",");
      item.value = imageUrls;
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.previewImageUrl = file.url;
      this.previewDialogVisible = true;
    },
    checkForm() {
      // 用户pin和用户昵称始终必填
      if (!this.formData.customerPin) {
        this.$message.warning("请输入用户pin");
        return false;
      }
      if (!this.formData.memberNick) {
        this.$message.warning("请输入用户昵称");
        return false;
      }

      // 根据ruleFieldsList动态校验字段
      if (this.shouldShowField("姓名") && !this.formData.name.trim()) {
        this.$message.warning("请输入姓名");
        return false;
      }
      if (this.shouldShowField("手机号") && !this.formData.mobile.trim()) {
        this.$message.warning("请输入手机号");
        return false;
      }
      if (this.shouldShowField("订单号") && !this.formData.orderId.trim()) {
        this.$message.warning("请输入订单号");
        return false;
      }
      if (this.shouldShowField("地址") && !this.formData.address.trim()) {
        this.$message.warning("请输入地址");
        return false;
      }
      if (
        this.shouldShowField("地址") &&
        !this.formData.detailedAddress.trim()
      ) {
        this.$message.warning("请输入详细地址");
        return false;
      }
      if (this.shouldShowField("评价截图") && this.fileList.length == 0) {
        this.$message.warning("请上传评价截图");
        return false;
      }

      // 拓展信息校验
      if (
        this.expendFields &&
        this.expendFields.staticInfoNames &&
        this.expendFields.staticInfoNames.length > 0
      ) {
        for (let item of this.expendFile) {
          if (!item.value || item.value.trim() === "") {
            this.$message.warning(`${item.name}不能为空`);
            return false;
          }
        }
      }

      return true;
    },
    handleConfirm() {
      // 处理表单提交逻辑
      if (!this.checkForm()) {
        return;
      }
      let commentImage = "";
      if (this.fileList && this.fileList.length > 0) {
        commentImage = this.fileList.map((file) => file.url);
      }

      // 构建提交数据，只包含显示的字段
      const submitData = {
        customerPin: this.formData.customerPin,
        memberNick: this.formData.memberNick,
        activityId: this.activityId,
        commentImage,
      };

      if (this.type == "edit") {
        submitData.id = this.formData.id;
      }
      // 根据ruleFieldsList添加需要的字段
      if (this.shouldShowField("姓名") && this.formData.name.trim()) {
        submitData.name = this.formData.name;
      }
      if (this.shouldShowField("手机号") && this.formData.mobile.trim()) {
        submitData.mobile = this.formData.mobile;
      }
      if (this.shouldShowField("订单号") && this.formData.orderId.trim()) {
        submitData.orderId = this.formData.orderId;
      }
      if (this.shouldShowField("地址") && this.formData.address.trim()) {
        submitData.address = this.formData.address;
      }
      if (
        this.shouldShowField("地址") &&
        this.formData.detailedAddress.trim()
      ) {
        submitData.detailedAddress = this.formData.detailedAddress;
      }

      if (this.expendFile && this.expendFile.length > 0) {
        const staticInfoNames = this.expendFile.map((item) => ({
          value: item.value,
          type: item.type,
          name: item.name,
        }));
        submitData.staticInfoNames = staticInfoNames;
      }
      console.log("--- ~ submitData:---", submitData);
      addUserProfile(submitData).then((res) => {
        if (res.code == 1) {
          this.$message.success(this.type == "add" ? "新增成功" : "修改成功");
          this.dialogVisible = false;
          this.$emit("updateList");
        } else {
          this.$message.error(res.message || "新增失败");
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.w-input {
  width: 400px;
}

.review-images-upload {
  .upload-tips {
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    line-height: 1.5;
  }
}

// 自定义上传组件样式
:deep(.el-upload--picture-card) {
  width: 104px;
  height: 104px;
  line-height: 104px;
}

:deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 104px;
  height: 104px;
}
</style>
